/* eslint-disable no-underscore-dangle */
import CookieManager from 'utils/packages/cookieManager';
import React, { useCallback, useEffect, useLayoutEffect, useRef, useState, } from 'react';
import { Alert, StatusBar, StyleSheet, View } from 'react-native';
import { WebView } from 'utils/packages/webview';
import { useAppDispatch } from 'store/hooks';
import { AppView } from 'design-system';
import { onSwitchCompleted } from '../../../../../actions';
import Amplitude from '../../../../../utils/amplitude';
import Sentry from '../../../../../utils/sentry';
const getAYearFromNow = () => {
    const aYearFromNow = new Date();
    aYearFromNow.setFullYear(aYearFromNow.getFullYear() + 1);
    return aYearFromNow;
};
const EnergyApplication = ({ navigation, route, }) => {
    const aYearFromNow = useRef(getAYearFromNow());
    const [cookieString] = useState(() => {
        const { name, value, domain } = route.params.data.webview.cookie;
        return `${name}=${value}; domain=${domain}; origin=/; path=/; version=1; expires=${aYearFromNow.current};`;
    });
    useLayoutEffect(() => {
        navigation.setOptions({
            headerStyle: {
                backgroundColor: '#4542f8',
            },
        });
    }, []);
    const refWebview = useRef(null);
    useEffect(() => {
        Amplitude.logEvent('MoneySuperMarket.EnergyApplication');
        const { domain } = route.params.data.webview.cookie;
        CookieManager.setFromResponse(domain, cookieString).then(() => {
            // the cookie is set at the beginning as a safeguard against getting to it too late
            CookieManager.get(domain)
                .then((cookies) => {
                CookieManager.clearAll().then(() => {
                    CookieManager.setFromResponse(domain, cookieString);
                    if (cookies._dtl_cookie_preferences)
                        CookieManager.setFromResponse(domain, `_dtl_cookie_preferences=${cookies._dtl_cookie_preferences.value}; domain=${domain}; origin=/; path=/; version=1; expires=${aYearFromNow.current};`);
                });
            })
                .catch(() => {
                CookieManager.clearAll().then(() => {
                    CookieManager.setFromResponse(domain, cookieString);
                });
            });
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const dispatch = useAppDispatch();
    const onShouldStartLoadWithRequest = useCallback(({ url }) => {
        if (url && url.includes('emma://switchingsuccess/')) {
            refWebview.current?.stopLoading();
            const splittedValues = url
                .replace('emma://switchingsuccess/', '')
                .split('/');
            const applicationId = splittedValues[0];
            const partnerId = splittedValues[1];
            dispatch(onSwitchCompleted({ applicationId, partnerId }));
            const { name } = route.params;
            navigation.navigateDeprecated('SwitchCompleted', { name });
            return false;
        }
        if (url && url.includes('emma://switchingerror')) {
            Alert.alert('Error', 'We have encountered an error in processing this application.');
            Sentry.logError({
                filename: 'EnergyApplication.js',
                message: 'Switching Application Error',
            });
            return false;
        }
        return true;
    }, [route.params]);
    const { params } = route;
    const { data } = params;
    const { webview } = data;
    const { url } = webview;
    const INJECTEDJAVASCRIPT = "const meta = document.createElement('meta'); meta.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=0.99, user-scalable=0'); meta.setAttribute('name', 'viewport'); document.getElementsByTagName('head')[0].appendChild(meta);";
    return (<AppView avoidHeader>
      <View style={styles.container}>
        <StatusBar barStyle="light-content" animated/>
        <WebView ref={refWebview} source={{
            uri: url,
            headers: {
                Cookie: cookieString,
            },
        }} injectedJavaScript={INJECTEDJAVASCRIPT} originWhitelist={['*']} onShouldStartLoadWithRequest={onShouldStartLoadWithRequest} style={styles.content} sharedCookiesEnabled thirdPartyCookiesEnabled/>
      </View>
    </AppView>);
};
const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#4542f8',
    },
    content: {
        flex: 1,
        backgroundColor: '#4542f8',
    },
});
export default EnergyApplication;
